module.exports = __webpack_public_path__ + "img/shuji.a269a92a.png";